import createRoute   from '@widesk-ui/tools/createRoute';
import DeliveryModel from '@models/shop/DeliveryModel';

export default createRoute.dashboard('/deliveries', 'shop', 'DeliveryDashboard', DeliveryModel.localize());
